import {
    SET_PRODUCT_SETTINGS_DATA_LOADING,
    SET_PRODUCT_SETTINGS_DATA,
    CLEAR_PRODUCT_SETTINGS_DATA,
} from "../actions/types";

const initialState = {
    isLoading: false,
    productSettingsData: [],
};

export default function (state = initialState, action) {
    const { type, payload } = action;
    switch (type) {
        case SET_PRODUCT_SETTINGS_DATA_LOADING:
            return {
                ...state,
                isLoading: payload,
            };
        case SET_PRODUCT_SETTINGS_DATA:
            return {
                ...state,
                productSettingsData: Array.isArray(payload) ? [...payload] : [],
                isLoading: false,
            };
        default:
            return state;
    }
}
